export const imageMapsUploader = 'imageMaps';
